var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSns5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1740 -3569)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 8",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1740 3569)",
    style: {
      fill: "#303542"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2.892a8.323 8.323 0 0 1-2.357.637 4.057 4.057 0 0 0 1.8-2.233 8.321 8.321 0 0 1-2.6.98A3.952 3.952 0 0 0 14.926 1a3.912 3.912 0 0 0-4.1 4.023 4.759 4.759 0 0 0 .1 1.012A11.973 11.973 0 0 1 2.392 1.74a3.959 3.959 0 0 0-.556 2.028 4.018 4.018 0 0 0 1.826 3.36A4.137 4.137 0 0 1 1.8 6.623v.051a4.055 4.055 0 0 0 3.291 3.959 4.165 4.165 0 0 1-1.851.069 4.094 4.094 0 0 0 3.832 2.8 8.317 8.317 0 0 1-5.1 1.729A8.039 8.039 0 0 1 1 15.176 11.75 11.75 0 0 0 7.423 17 11.323 11.323 0 0 0 18.9 5.511c0-.174 0-.349-.011-.521A8.583 8.583 0 0 0 21 2.892z",
    transform: "translate(1749 3580)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSns5);
export default __webpack_public_path__ + "static/media/sns_5.01bd2e413995a7b1be7cfc84a7ca5d79.svg";
export { ForwardRef as ReactComponent };